export interface IHeadingLink {
  linkId: string
  isChild: boolean
  linkName: string
}
/**
 * Service to inject content into Documentation pages
 */
export default class ContentService {
  /**
   * 1. Injects ID into document headings (h1,h2...)
   * 2. Uses these headings as links for inter-page navigation
   * @param htmlString string content for html
   *  @returns object with modifiedHTML and array of links
   */
  injectIdIntoHtml_returnHtmlAndLinks(htmlString: string): {
    modifiedHtml: string
    linksArray: IHeadingLink[]
  } {
    const headingRegex = /<h([1-2])>(.*?)<\/h[1-2]>/gi

    const linksArray: IHeadingLink[] = []
    let index = 0

    // Replace each heading with modified version containing the "id" attribute
    const modifiedHtml = htmlString?.replace(headingRegex, (match, headingLevel, content) => {
      index++
      const id = `content${index}`
      const linkName = `${content}`
      /*Unused at the moment */
      // const link = `#${content.replaceAll(' ', '-')}`
      // console.log("HEADING LEVEL", headingLevel)
      const headingLinkItem: IHeadingLink = {
        linkName: linkName,
        linkId: id,
        isChild: headingLevel == '2' ? true : false
      }
      linksArray.push(headingLinkItem)
      return `<h${headingLevel} id="${id}">${content}</h${headingLevel}>`
    })

    return { modifiedHtml, linksArray }
  }

  /**
   * Converts OEMBED element into IFRAME for videos
   * @param htmlString string HTML
   * @returns modified HTML as string
   */
  convertOembedToIframe(htmlString: string): string {
    if (!htmlString) return ''

    const oembedRegex = /<oembed url="([^"]+)"><\/oembed>/gi

    // Replace each <oembed> element with an iframe
    const modifiedHtml = htmlString.replace(oembedRegex, (match, url) => {
      // console.log('MATCH', match)
      // console.log('url', url)

      const videoId = this.extractVideoId(url)
      if (videoId) {
        const iframeSrc = `https://www.youtube.com/embed/${videoId}`

        return `<iframe width="100%" height="100%" src="${iframeSrc}" frameborder="0" allowfullscreen></iframe>`
      } else {
        return match // No valid video ID found, keep the original <oembed> element
      }
    })

    return modifiedHtml
  }

  /**
   * Uses regex to identify youtube video ID
   * @param youtubeUrl url of youtube video
   * @returns string youtubeID
   */
  private extractVideoId(youtubeUrl: string): string | null {
    // Regular expression pattern to extract the video ID from the YouTube URL
    const videoIdRegex =
      // eslint-disable-next-line no-useless-escape
      /(?:[?&]vi?|\/embed\/|\/\d{1,2}\/|\/vi?|youtu\.be\/|\/embed\/|\/v\/|\/e\/|\/watch\?v=|\/watch\?vi=|https?:\/\/(?:www\.)?youtube\.com\/(?:(?:watch|embed)(?:\.php)?(?:\?|#!?)(?:.*&)?v(?:i)?=|v(?:i)?\/|embed\/|shorts\/|c\/))([^\s&?\/]+)/i
    const match = youtubeUrl.match(videoIdRegex)
    return match ? match[1] : null
  }
}

/**
 * @param item - is id
 * @description - to make smooth scrolling on selecting the content
 */
export const scrollToElement = (item: string) => {
  const targetElement = document.querySelector(item)

  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' })
  }
}
